import React from 'react';
import { Link } from 'react-router-dom';
import profileImage from '../assets/images/profile.jpeg';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <div className="home-content">
        <div className="text-section">
          <span className="subtitle">Classical Soprano</span>
          <h1 className="title">
            ARIA
            <span className="highlight">SOOHYUN JO</span>
          </h1>
          <p className="description">
            "A voice of exceptional purity and emotional depth"
          </p>
          <div className="cta-buttons">
            <Link to="/repertoire" className="btn primary">Repertoire</Link>
            <Link to="/contact" className="btn secondary">Contact</Link>
          </div>
        </div>
      </div>
      <div className="image-section">
        <img src={profileImage} alt="Aria Soohyun Jo" className="profile-image" />
      </div>
    </div>
  );
}

export default Home; 